module.exports = __webpack_public_path__ + "static/dimmer1-27fa1efccf69fe1a81d36ae4841fa67a.png";